export const images = {
  iphone11: require('./assets/phones/iphone11.jpg'),
  iphone12: require('./assets/phones/iphone12.jpg'),
  iphone13: require('./assets/phones/iphone13.jpg'),
  iphone14: require('./assets/phones/iphone14.jpg'),
  samsung1: require('./assets/phones/samsung1.jpg'),
  samsung2: require('./assets/phones/samsung2.jpg'),
  samsung3: require('./assets/phones/samsung3.jpg'),
  motorola1: require('./assets/phones/motorola1.jpg'),
  motorola2: require('./assets/phones/motorola2.jpg'),
  notebook1: require('./assets/notebooks/notebook1.jpg'),
  notebook2: require('./assets/notebooks/notebook2.jpg'),
  notebook3: require('./assets/notebooks/notebook3.jpg'),
  notebook4: require('./assets/notebooks/notebook4.jpg'),
  auri1: require('./assets/headphones/auri1.jpg'),
  auri2: require('./assets/headphones/auri2.jpg'),
  auri3: require('./assets/headphones/auri3.jpg'),
  auri4: require('./assets/headphones/auri4.jpg'),
};
